import { render, staticRenderFns } from "./virtualCardList.vue?vue&type=template&id=4684272a&"
import script from "./virtualCardList.vue?vue&type=script&lang=js&"
export * from "./virtualCardList.vue?vue&type=script&lang=js&"
import style0 from "./virtualCardList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports